(async () => {
  const { StandardEvents } = await import('@shopify/events');
  if (customElements.get('dr-product-assistance')) return;

  class DonRelojProductAssistance extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.sequence = 0;
      this.scope = this.closest('.shopify-section, dialog');
      this.update(JSON.parse(this.dataset.variant || 'null'));
      this.scope?.addEventListener(StandardEvents.productSelect, this.onProductSelect, {
        signal: this.controller.signal,
      });
    }

    disconnectedCallback() {
      this.sequence += 1;
      this.controller?.abort();
    }

    onProductSelect = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      if (event.target.closest('.shopify-section, dialog') !== this.scope) return;
      if (!event.promise) return;
      const sequence = ++this.sequence;
      this.setAttribute('aria-busy', 'true');
      this.update(null);
      event.promise.then(({ detail }) => {
        if (!this.isConnected || sequence !== this.sequence) return;
        const fresh = detail?.html?.querySelector('dr-product-assistance');
        if (fresh) {
          for (const key of ['productId', 'title', 'url', 'currency', 'message', 'casheaMessage', 'warrantyMessage', 'unselected', 'defaultVariant']) {
            this.dataset[key] = fresh.dataset[key];
          }
        }
        this.update(detail?.resource ?? null);
        this.removeAttribute('aria-busy');
      }).catch(() => {
        if (!this.isConnected || sequence !== this.sequence) return;
        this.update(null);
        this.removeAttribute('aria-busy');
      });
    };

    update(variant) {
      const initial = this.querySelector('[data-initial]');
      const installment = this.querySelector('[data-installment]');
      const button = this.querySelector('[data-whatsapp]');
      const valid = variant && Number.isFinite(Number(variant.price)) && Number(variant.price) >= 0;
      const cents = valid ? Number(variant.price) : 0;
      const initialCents = Math.round(cents * 0.20);
      const installmentCents = Math.round((cents - initialCents) / 3);
      const format = (amount, currencyDisplay = 'narrowSymbol') => new Intl.NumberFormat(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: this.dataset.currency || 'USD',
        currencyDisplay,
      }).format(amount / 100);
      if (initial) initial.textContent = valid ? format(initialCents) : '—';
      if (installment) installment.textContent = valid ? format(installmentCents) : '—';
      if (!button) return;
      const url = new URL(this.dataset.url, window.location.origin);
      if (variant?.id) url.searchParams.set('variant', String(variant.id));
      const values = {
        TITLE: this.dataset.title,
        VARIANT: variant ? (variant.title === 'Default Title' ? this.dataset.defaultVariant : variant.title) : this.dataset.unselected,
        PRICE: valid ? format(cents, 'code') : '—',
        URL: url.href,
      };
      const message = this.dataset.message.replace(/__(TITLE|VARIANT|PRICE|URL)__/g, (_, key) => values[key]);
      button.href = 'https://wa.me/584146927201?text=' + encodeURIComponent(message);
      for (const [selector, template] of [['[data-cashea]', this.dataset.casheaMessage], ['[data-warranty]', this.dataset.warrantyMessage]]) {
        const link = this.querySelector(selector);
        if (link && template) link.href = 'https://wa.me/584146927201?text=' + encodeURIComponent(template.replace(/__(TITLE|VARIANT|PRICE|URL)__/g, (_, key) => values[key]));
      }
    }
  }

  customElements.define('dr-product-assistance', DonRelojProductAssistance);
})();
